import { i18n } from "@translations/i18n";
import { initFetcher } from "itsf-ui-common";

export const fetcher = initFetcher(i18n.t("common:genericError"), i18n.t("common:unauthorizedError"), {});
